import React from "react";
import { Para } from "@irati-web/recognition/src/components/Polls/ClosedPoll/styled/Card";
import { FormattedMessage } from "@irati/utils/lang";
import ProductTile from "./Product";
import { Title } from "../styled";
var TenantProducts = function (_a) {
    var active = _a.active, inactive = _a.inactive;
    return (React.createElement(React.Fragment, null,
        active.map(function (product) { return React.createElement(ProductTile, { product: product, key: product.product }); }),
        active.length === 0 && React.createElement(Para, null,
            React.createElement(FormattedMessage, { id: "home.products.noActive" })),
        inactive.length !== 0 &&
            React.createElement(React.Fragment, null,
                React.createElement(Title, null,
                    React.createElement(FormattedMessage, { id: "home.products.inactive.title" })),
                inactive.map(function (product) { return React.createElement(ProductTile, { product: product, key: product.product }); }))));
};
export default TenantProducts;
